// HeaderTop.propTypes.js

import PropTypes from 'prop-types';
import commonConstants from "../../../constants/commonConstants";

/**
 * PropTypes for the HeaderTop component.
 */
export const headerTopPropTypes = {
  /**
   * Background for the Paper component.
   * Should be a valid CSS color string or gradient (e.g., 'linear-gradient(270deg, #11728D 37%, #3CB0C7 100%)').
   */
  background: PropTypes.string,

  /**
   * Height for the Paper component.
   * Should be a valid CSS size string (e.g., '63px', '4rem').
   */
  height: PropTypes.string,

  /**
   * Paragraph text to be displayed inside the TypographyBlock.
   */
  paragraph: PropTypes.string,
};

/**
 * Default props for the HeaderTop component.
 */
export const headerTopDefaultProps = {
  background: `linear-gradient(270deg, ${commonConstants?.SECONDARY_COLOR} 37%, #3CB0C7 100%)`,
  height: '63px',
  paragraph: '1.866.680.5143',
};
